export const ExecutionTypeDropdown = [
  { id: 'ALL', name: 'ALL' },
  { id: 'ONE', name: 'ONE' },
  { id: 'FIRST', name: 'FIRST MATCH' }
]

export const ExecutionTypes = {
  all: 'ALL', one: 'ONE', first: 'FIRST'
}



// WEBPACK FOOTER //
// ./src/views/Common/Partials/StaticData/ExecutionTypes.tsx